import { FolderRecord, fromJSON, IFolderData } from "common/records/Folder";
import { Map, Record } from "immutable";
import { fetch, receive, reset, loaded } from "common/reducers/Utils";
import { RootActions, RootState } from "common/reducers";
import {
  FolderActions,
  CREATE_FOLDER,
  EDIT_NAME,
  EDIT_SORT_ORDER,
  FETCH_FOLDER,
  RECEIVE_FOLDER,
  RECEIVE_FOLDERS,
  REMOVE_FOLDER,
  RESET_FOLDER,
  SET_FOLDER_LOADED,
} from "common/reducers/folder.actions";
import { IdsManagementActions } from "common/reducers/idsManagement.actions";
import { reducer as idsManagementReducer } from "common/reducers/idsManagement.reducer";

export const FolderStateRecord = Record({
  byId: Map<number, FolderRecord>(),
  lastSavedById: Map<number, FolderRecord>(),
  unsavedId: -1,
});

export const initialState = FolderStateRecord();
export type FolderState = typeof initialState;

const model = "folders";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case FETCH_FOLDER:
      return fetch(state, model, fromJSON({ id: action.payload.id })) as RootState;

    case RECEIVE_FOLDER:
      const folder = fromJSON({ ...action.payload.folder, loading: false });
      return receive(state, model, folder) as RootState;

    case RESET_FOLDER:
      return reset(state, model, action.payload.id) as RootState;

    case CREATE_FOLDER:
      const unsavedId = state.getIn([model, "unsavedId"]);
      state = reducer(
        state,
        FolderActions.receiveFolder({
          id: unsavedId,
          parent_id: action.payload.folderParentId,
          createParams: action.payload.createParams,
        } as IFolderData),
      );
      state = idsManagementReducer(state, IdsManagementActions.pushId(unsavedId, model));

      return state.setIn([model, "unsavedId"], unsavedId - 1);

    case EDIT_NAME:
      return state.setIn([model, "byId", action.payload.folderId, "name"], action.payload.name);

    case EDIT_SORT_ORDER:
      return state.setIn([model, "byId", action.payload.folderId, "sort_order"], action.payload.sortOrder);

    case SET_FOLDER_LOADED:
      return loaded(state, model, action.payload.id) as RootState;

    case REMOVE_FOLDER:
      state = idsManagementReducer(state, IdsManagementActions.removeId(action.payload.id, model));

      return state.deleteIn([model, "byId", action.payload.id]);

    case RECEIVE_FOLDERS:
      action.payload.folders.forEach((folder) => {
        state = reducer(state, FolderActions.receiveFolder(folder));
      });
      return state;

    default:
      return state;
  }
};
